<template>
  <o-form-group :label="label" :error-field="errorField" :class="[{'has-error': errorField in $root.errors}, groupClass]">
    <template v-if="mask || format">
      <o-input-mask-control v-model="localValue" :type="type" :readonly="readonly" :placeholder="placeholder" :mask="mask" :prepend="prepend" :append="append" :format="format" :description="description" :descriptionClass="descriptionClass" :rightdescription="rightdescription" :rightdescriptionClass="rightdescriptionClass" :showInfo="showInfo" :showInfoDescirption="showInfoDescirption"></o-input-mask-control>
    </template>
    <template v-else>
      <o-input-control v-model="localValue" :type="type" :readonly="readonly" :placeholder="placeholder" :prepend="prepend" :append="append" :step="step"></o-input-control>
    </template>
  </o-form-group>
</template>

<script>
  export default {
    name: 'o-input',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      type: {
        type: String,
        default: 'text'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      errorField: {
        type: String
      },
      placeholder: {
        type: String
      },
      mask: {
        type: String
      },
      append: {
        type: String
      },
      prepend: {
        type: String
      },
      format: {
        type: String,
        default: ''
      },
      step: {
        type: Number,
        default: 0.01
      },
      description: {
        type: String,
        default: ''
      },
      descriptionClass: {
        default: 'text-muted'
      },
      rightdescription: {
        type: String,
        default: ''
      },
      rightdescriptionClass: {
        default: 'text-muted'
      },
      showInfo: {
        type: Boolean,
        default: false
      },
      showInfoDescirption: {
        type: String,
        default: ''
      },
      groupClass: {
        type: [String, Array],
        default: ''
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
